import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CALIDAD_EMBARQUE } from '../../../../config/tables'

export default function CalidadMercaderiaEmbarcadaView () {
  return <MuiTable id={TABLA_CALIDAD_EMBARQUE} />
}
